'use-strict';

import { passwordStrength } from 'check-password-strength';

/* @ngInject */
export default function PasswordChangeController(
  $rootScope,
  $scope,
  $http,
  toastService,
  configService,
) {
  const passwordOptions = configService.get('passwordStrengthOptions');
  const minPasswordStrength = configService.get('minPasswordStrength');

  const init = () => {
    $scope.passwordChange = {};
    $scope.passwordStrength = {
      strength: 0,
      strengthValue: passwordOptions.find((o) => o.id === 0).value,
      strengthColor: passwordOptions.find((o) => o.id === 0).color,
      length: false,
      number: false,
      capitalLetters: false,
      specialCharacter: false,
    };
  };

  $scope.newPasswordChange = () => {
    const minStrength = passwordOptions[minPasswordStrength];
    const strength = passwordStrength($scope.passwordChange.newPassword, passwordOptions);

    $scope.passwordStrength = {
      strength: strength.id,
      strengthValue: strength.value,
      strengthColor: passwordOptions.find((o) => o.id === strength.id).color,
      length: $scope.passwordChange.newPassword.length >= minStrength.minLength,
      number: strength.contains.includes('number'),
      capitalLetters: strength.contains.includes('lowercase') && strength.contains.includes('uppercase'),
      specialCharacter: strength.contains.includes('symbol'),
    };
  };

  $scope.apiUpdatePassword = () => {
    if ($scope.passwordChange.newPassword !== $scope.passwordChange.newPasswordRepeat) {
      toastService.toast('error', 'Die beiden Passwörter stimmen nicht überein.');
    // eslint-disable-next-line max-len
    } else if (passwordStrength($scope.passwordChange.newPassword, passwordOptions).id < minPasswordStrength) {
      toastService.toast('error', 'Dein Passwort ist noch nicht sicher genug.');
    } else {
      $http.post(`${API_URL}/api/users/change-password`, {
        oldPassword: $scope.passwordChange.currentPassword,
        newPassword: $scope.passwordChange.newPassword,
      })
        .then(() => {
          toastService.toast('success', 'Das Passwort wurde erfolgreich geändert');
          $rootScope.$broadcast('passwordChangeSuccess');
        })
        .catch((res) => {
          if (res.status === 403) return toastService.toast('error', 'Das eigegebene Passwort war falsch');
          return toastService.toast('error', 'Fehler beim Ändern des Passworts');
        });
    }
  };

  init();
}
